module.exports = __webpack_public_path__ + "assets/img/warrior-name-1065497e.png";